<template>
  <v-container fluid class="ma-0 pb-0 pt-0 fill-screen" :style="bgStyle">
    <v-row class="fill-height" justify="center" align="center">
      <!-- Flechas laterales SOLO en Interify -->
      <v-col v-if="!isPortalEci" align-self="end" cols="4">
        <v-img
          contain
          height="100"
          style="transform: rotate(180deg)"
          :src="FlechasAmarillas"
        ></v-img>
      </v-col>

      <v-col justify="center" align="center" cols="4" class="card-container">
        <v-card
          class="main-card pt-6 pb-5 pl-1 pr-1 mt-5 mb-2"
          :class="{ 'eci-card': isPortalEci }"
          justify="center"
          align="center"
          rounded="xl"
        >
          <v-img height="35" min-width="128" contain :src="headerLogo"></v-img>

          <div class="main-container-input" v-if="!cargando">
            <InputCorreo
              v-if="step === 1"
              :email="email"
              :is-portal-eci="isPortalEci"
              @sendEmail="sendEmail"
            />
            <RevisaCorreo v-if="step === 2" :is-portal-eci="isPortalEci" />
          </div>
          <div v-else>
            <v-row
              style="
                width: 100%;
                padding: 16px;
                border-radius: 20px;
                min-height: 300px;
              "
              class="d-flex align-md-center justify-md-center"
            >
              <v-card-text class="text-center">
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex align-md-center justify-md-center"
                  >
                    <v-img
                      class="responsive"
                      contain
                      max-height="150"
                      max-width="300"
                      :src="loginTemplate.createAccount"
                    ></v-img>
                  </v-col>
                  <v-col cols="12">
                    <h1>Enviando correo...</h1>
                    <span>Espere un momento por favor</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-row>
          </div>
          <template v-if="!isPortalEci">
            <!-- footer Interify -->
            <v-img
              class="mt-6 mb-1 pa-0"
              height="26"
              min-width="80"
              :src="LogoInterBlack"
              contain
            ></v-img>

            <p
              class="ma-0 pa-0 mb-3"
              style="
              font-size: 10px;
              font-family: 'Montserrat';
              text-align: center;
              color: #6d6f71;
              font-weight: 500;
              "
            >
              Interify 2024 © Todos los Derechos Reservados
            </p>
          </template>
        </v-card>
      </v-col>

      <!-- Flechas laterales SOLO en Interify -->
      <v-col v-if="!isPortalEci" align-self="start" cols="4">
        <v-img
          class="mt-8"
          contain
          height="100"
          :src="FlechasAmarillas"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogoInter from "@/assets/interify.svg";
import LogoInterBlack from "../../../assets/Logo_Interify_black.svg";
import FlechasAmarillas from "../../../assets/patron-amarillo-fondo.svg";
import InputCorreo from "./InputCorreo.vue";
import RevisaCorreo from "./RevisaCorreo.vue";
import loginData from "../../../helpers/data/data-login-template.json";
import { mainAxios } from "../../../mainAxios";
import LogoInterHorizontal from "@/assets/img/intermx-1.svg";
import LogoIntershort from "@/assets/inter-blue.f023d28c.svg";
export default {
  name: "RecuperarContrasenia",
  components: {
    InputCorreo,
    RevisaCorreo,
  },
  data() {
    return {
      LogoInter,
      LogoInterBlack,
      FlechasAmarillas,
      step: 1,
      email: "",
      cargando: false,
      loginTemplate: loginData,
      emailData: {},
      globalConfig: JSON.parse(localStorage.getItem("globalConfig")) ?? {},
      LogoIntershort,
    };
  },
  computed: {
    isPortalEci() {
      const crmName = this.globalConfig?.showCrmName;
      if (crmName) {
        return crmName === "portalEci";
      }

      const host = window.location.hostname.toLowerCase();

      const esEciHost =
        host.includes("portal-eci") ||
        host.includes("porta-eci") ||
        host.includes("eci");

      return esEciHost;
    },
    headerLogo() {
      // portal ECI usa el logo horizontal; interify mantiene el original
      return this.isPortalEci ? LogoInterHorizontal : this.LogoInter;
    },
    bgStyle() {
      // fondo claro como el login de ECI; interify mantiene el azul oscuro
      const bg = this.isPortalEci ? "#F6F5F9" : "#001B30";
      return { backgroundColor: bg };
    },
  },
  methods: {
    startRedirectCountdown() {
      this.showSuccessAlert = true;
      this.remainingSeconds = 30;

      // limpiar si ya había un timer
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        this.remainingSeconds--;
        if (this.remainingSeconds <= 0) {
          clearInterval(this.countdownTimer);
          this.$router ? this.$router.push("/") : (window.location.href = "/");
        }
      }, 1000);
    },

    // isNextStep(isNext) {
    //   if (isNext) {
    //     this.step++;
    //     console.log(this.email);
    //   }
    // },
    async sendEmail(email) {
      // Validación básica del correo
      if (!email || !/.+@.+\..+/.test(email)) {
        this.$toast.warning("Ingresa un correo válido");
        return;
      }

      this.emailData = {
        email: email,
        dominio: window.location.origin,
        crm:
          JSON.parse(localStorage.getItem("globalConfig"))?.showCrmName ||
          "interify",
      };
      this.cargando = true;

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      mainAxios
        .post("/v1/prospecto/recovery-password", this.emailData, config, {
          headers: { "Content-Type": "application/json" },
        })
        .then(({ data }) => {
          if (data.status === "SUCCEEDED") {
            this.cargando = false;
            this.step = 2;
            this.$toast.success("Se envió la solicitud correctamente");
            this.startRedirectCountdown();
          } else if (data.status === "FAILED") {
            this.cargando = false;
            this.$toast.warning(data.message, {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.fill-screen {
  min-height: 100vh;
  width: 100vw;
}

.fill-height {
  margin: auto;
  width: 90%;
}

.card-container {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-card {
  margin: auto;
  width: 80%;
}
.main-container-input {
  width: 90%;
}
</style>
